import React, { useEffect } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './styling/index.css';

const container = document.getElementById('root');

const ClientApp = () => {
  useEffect(() => {
    document.getElementById('server-rendered-content')?.remove();
  }, []);

  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

if (container.hasChildNodes()) {
  hydrateRoot(container,
    <React.StrictMode>
      <ClientApp />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ClientApp />
    </React.StrictMode>
  );
}
